<style lang="scss" scoped>
.title {
	margin-top: 0.4rem;
}
::v-deep .cell_title {
	color: $font_color_val;
	font-size: 0.24rem;
}
.min_h{
	min-height: calc(100vh - 1.2rem);
}
</style>

<template>
	<div class="safeguard_clause">
		<div class="min_h">
			<top-nav @back="$router.go(-1)">保障条款</top-nav>
			<active-title class="title">主条款</active-title>
			<van-cell v-for="(item, index) in mainClausesList" :key="index" :title="item.docName" @click="cellClick(item)" title-class="cell_title" value-class="cell_value" :border="false" is-link />
			<active-title class="title">附加条款</active-title>
			<van-cell v-for="(item, index) in additionClausesList" :key="index" :title="item.docName" @click="cellClick(item)" title-class="cell_title" value-class="cell_value" :border="false" is-link />
		</div>
		
		<div class="tip_copyright">本系统已获软件著作权，受《中华人民共和国著作权法》和《计算机软件保护条例》的保护，未经许可请勿擅自使用、复制、传播软件。</div>

	</div>
</template>

<script>
import { Cell } from 'vant';
import { porductClause } from '@/request/api';

export default {
	name: 'cpsSafeguardClause',
	components: {
		[Cell.name]: Cell,
	},
	props: {
		productId: {
			type: [Number, String],
			required: true,
		},
		comboId: {
			type: [Number, String],
		},
	},
	created() {
		this.getPorductClause(this.productId);
	},
	data() {
		return {
			mainClausesList: [],
			additionClausesList: [],
			serve: '',
		};
	},
	methods: {
		getPorductClause(productId) {
			porductClause(productId, { comboId: this.comboId }).then(res => {
				this.mainClausesList = res.mainClausesList;
				this.additionClausesList = res.additionClausesList;
				this.serve = res.productFileServer;
			});
		},

		cellClick(info) {
			window.open(this.serve + info.docLink, '_blank');
		},
	},
};
</script>
